import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'

import { NotFound } from 'src/components/NotFound'

import { KioskLayout } from './layout'
//import { Login, Logout, ForgotPassword, ResetPassword } from './pages'

export const KioskRouter = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route path={`${path}/driver-check-in`} exact>
        <KioskLayout>
          hello
        </KioskLayout>
      </Route>
      <Route path='*'>
        <NotFound />
      </Route>
    </Switch>
  )
}
